import { useCallback } from 'react';
import { bridge } from '../../../bridge';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';
import { appendParams, finalizeUrl, getDefaultDeeplink } from '../../utils';

export const useMoveToRecentlyViewedGoods = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigation: any = useRootStackNavigation();

  return useCallback(() => {
      const url = getDefaultDeeplink();

      appendParams(url, 'screen', 'RecentlyViewedGoods');
      bridge.openDeeplink(finalizeUrl(url), {
          webCallback: () => {
              navigation.navigate('RecentlyViewedGoods');
          },
      });
  }, [navigation]);
};